import mutations from "./mutations";
import { IPayment } from "@/apps/merchant3/models/IPayment";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {} as IPayment,
  actions,
  getters,
  mutations,
};
